function initTiltOnElement(tile) {
    const img = tile.querySelector('img');

    if (!img) return;

    const maxTilt = Number(tile.dataset.tiltMax) || 10;
    const scale = Number(tile.dataset.tiltScale) || 1.05;
    let rafId;

    function setTransform(s, x, y) {
        img.style.transform =
            x === undefined ? `scale(${s})` : `scale(${s}) rotateX(${x}deg) rotateY(${y}deg)`;
    }

    function reset() {
        img.style.transform = 'none';
    }

    function onPointerMove(e) {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
            const { left, top, width, height } = tile.getBoundingClientRect();
            const x = (e.clientX - left) / width - 0.5;
            const y = (e.clientY - top) / height - 0.5;

            const tiltX = (y * maxTilt * -1).toFixed(2);
            const tiltY = (x * maxTilt).toFixed(2);

            setTransform(scale, tiltX, tiltY);
            rafId = null;
        });
    }

    tile.addEventListener('pointermove', onPointerMove);
    tile.addEventListener('pointerleave', reset);
    tile.addEventListener('focus', () => setTransform(scale));
    tile.addEventListener('blur', reset);

    tile.dataset.tiltInitialized = '1';
}

export const tiltListener = () => {
    const tiltElements = [...document.querySelectorAll('.js-tilt')].filter(
        (el) => !el.dataset.tiltInitialized
    );

    tiltElements.forEach(initTiltOnElement);
};
